import { Button, Drawer } from "@components";
import { Input } from "@components/Input";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/forms.module.scss";
import { Environment } from "shared/core/Environment";

dayjs.extend(customParseFormat);
require("dayjs/locale/br");

const useTypes = {
  TODAY: "TODAY",
  FUTURE_DAY: "FUTURE_DAY",
};

export const SpecificDayConditionalForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  boxes,
}) => {
  const [date, setDate] = useState(node.data?.date || "");
  const [use_type, setUseType] = useState(node.data?.use_type || null);

  const hasPushCreative = !!boxes.some((b) => b.type === "PushCreativeAction");

  useEffect(() => {
    onChange &&
      onChange({
        ...node,
        data: { ...node.data, date, use_type: use_type },
      });
  }, [date, use_type]);

  const validate = () => {
    const today = dayjs();
    const creative_date = dayjs(date, "DD/MM/YYYY", "pt-br", true);


    // const isCocoBambu = Environment.id === 49;
    // if (hasPushCreative && creative_date.isSame(today, "day") && !isCocoBambu) return false;

    return (
      creative_date.isValid() &&
      (creative_date.isSame(today, "day") || creative_date.isAfter(today))
    );
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title="Em um dia específico"
    >
      <p className={styles.label}>Defina o dia especifico</p>

      <Input
        placeholder="dd/mm/aaaa"
        mask="99/99/9999"
        type="tel"
        value={date}
        onChange={(e) => {
          const today = dayjs();
          const newDate = dayjs(e.target.value, "DD/MM/YYYY");
          const isSame = newDate.isSame(today, "day");

          setDate(e.target.value);

          if (isSame) setUseType(useTypes.TODAY);
          else setUseType(useTypes.FUTURE_DAY);
        }}
        autoFocus
      />

      <div className={styles.footer}>
        <Button
          onClick={() => onSave({ ...node, data: { ...node.data, date } })}
          className="w-100"
          disabled={!validate()}
          design="primary"
        >
          Aplicar
        </Button>
      </div>
    </Drawer>
  );
};
